import React, { Component } from 'react';
import QRCode from 'qrcode.react';
import Top_Bar from '../../Part_Sample/Top_Bar';

export default class QR_Generator extends Component {
	constructor(props) {
		super(props);
		this.state = {
		}
	}

	handlePrevious = () => {
		window.app.content_area.current.switch_content.current.handleShowBottomMenu();
		this.props.content_handler('System');
	}

	render() {
		let style = {
			textAlign: 'center',
			width: '100%',
		}

		let main_content_style = {
			position: 'fixed',
			top: 0,
			width: '100%',
			height: this.props.height,
		}

		let controller = {};
		controller.ip_addr = this.props.receiver.active_controller.ip_addr;
		controller.mac_addr = this.props.receiver.active_controller.mac_addr;
		controller.model = this.props.receiver.active_controller.model;
		controller.version = this.props.receiver.active_controller.version;
		controller.ssc_connect = this.props.receiver.active_controller.ssc_connect;
		controller.ssc_url = this.props.receiver.active_controller.ssc_url;
		controller.name = this.props.receiver.active_controller.name;
		if (!this.props.receiver.is_mobile) controller.name = this.props.receiver.active_controller.web_controller_name;

		let QR_Code_value = window.btoa(JSON.stringify(controller));

		return (
			<div style={style}>
				<div id='main_content' style={main_content_style} className='slideInDown noScrollBar'>
					<Top_Bar
						width={this.props.width}
						title={this.props.receiver.getString('qr_code_gen')}
						left_button_type={'back'}
						handleLeftButton={this.handlePrevious}
					/>
					<div style={{ marginTop: 20, overflow: 'auto', paddingBottom: 60, height: this.props.height - 84 }}>
						<div style={{ textAlign: 'center', marginTop: 20 }}>
							<QRCode value={QR_Code_value} size={256} />
						</div>
						<div style={{ textAlign: 'left', marginTop: 20, marginLeft: 20 }}>
							<span className='footnote'>{this.props.receiver.getString('qr_instr')}</span>
						</div>
					</div>
				</div>
			</div>
		)
	}
}